import { Box, Button, DialogActions, DialogContent, Skeleton } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import appConfig from "src/config/env";
import { COMMOM_STATUS, orderStatusFormatted } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import useWarehouseTransferExport from "src/hooks/warehouse-transfer/useWarehouseTranferExport";
import useWarehouseTransferReview from "src/hooks/warehouse-transfer/useWarehouseTransferReview";
import DeliveredReceipt from "src/pages/orders/all-order/export-form/DeliveredReceipt";

export default function ImportReviewDialog({ val, transferFileType }) {
  const { closeDialog } = useAppGlobal();
  const [logId, setLogId] = useState();

  const { data, isLoading } = useWarehouseTransferReview(val?._id, {
    transferFileType: transferFileType,
  });
  const { mutate } = useProcessLogDetail(logId, {
    warehouse: val?.fromWarehouse?._id ?? val?.fromWarehouse,
  });

  const { trigger: printWT } = useWarehouseTransferExport();

  const handlePrint = async () => {
    const res = await printWT({
      body: {
        warehouseTransferIds: [val?._id],
        transferFileType: !!transferFileType ? transferFileType : orderStatusFormatted.Exported,
      },
    });
    if (res?.success) {
      setLogId(res?.data?._id);
      handleGetLog(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: 'notistack-confirm' });
    } else {
      return enqueueSnackbar(res?.error?.message ?? res?.error?.message, {
        variant: "error",
      });
    }
  };

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;

    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            closeDialog();
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  return (
    <>
      <DialogContent>
        {isLoading ? (
          Array.from({ length: 10 }, (_, i) => {
            return (
              <Skeleton
                key={i}
                width="100%"
                height="44px"
              />
            );
          })
        ) : (
          <Box>
            <DeliveredReceipt
              isLoading={isLoading}
              html={data}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: "24px 24px 24px" }}>
        <Button
          onClick={handlePrint}
          fullWidth
          variant="contained"
        >
          In phiếu
        </Button>
      </DialogActions>
    </>
  );
}
